import { render, staticRenderFns } from "./oneGrantDialog.vue?vue&type=template&id=514a5b16&scoped=true"
import script from "./oneGrantDialog.vue?vue&type=script&lang=js"
export * from "./oneGrantDialog.vue?vue&type=script&lang=js"
import style0 from "./oneGrantDialog.vue?vue&type=style&index=0&id=514a5b16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514a5b16",
  null
  
)

export default component.exports